import { create } from 'zustand';

/**
 * 사용자 정보 타입 (임시)
 * TODO: OpenAPI spec에 정의 후 Orval 생성 타입으로 교체
 */
export interface User {
  id: string;
  email: string;
  name?: string | null;
  role?: string | null;
  provider?: string | null;
}

/**
 * 인증 상태 스토어
 *
 * 쿠키 기반 세션 인증:
 * - 세션 쿠키는 서버에서 관리 (httpOnly)
 * - 클라이언트는 user 정보만 메모리에 저장
 * - 페이지 로드 시 GET /api/auth/me로 세션 유효성 확인
 */
interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isSessionChecked: boolean;
}

interface AuthActions {
  setUser: (user: User) => void;
  clearUser: () => void;
  setSessionChecked: (value: boolean) => void;
}

type AuthStore = AuthState & AuthActions;

export const useAuthStore = create<AuthStore>()((set) => ({
  // State
  user: null,
  isAuthenticated: false,
  isSessionChecked: false,

  // Actions
  setUser: (user: User) =>
    set({
      user,
      isAuthenticated: true,
    }),

  clearUser: () =>
    set({
      user: null,
      isAuthenticated: false,
    }),

  setSessionChecked: (value: boolean) => set({ isSessionChecked: value }),
}));

/**
 * 컴포넌트 외부에서 사용하기 위한 유틸리티 함수
 * (API 클라이언트, 라우터 가드 등)
 */
export function getUser(): User | null {
  return useAuthStore.getState().user;
}

export function isAuthenticated(): boolean {
  return useAuthStore.getState().isAuthenticated;
}

export function setUser(user: User): void {
  useAuthStore.getState().setUser(user);
}

export function clearUser(): void {
  useAuthStore.getState().clearUser();
}

export function isSessionChecked(): boolean {
  return useAuthStore.getState().isSessionChecked;
}

export function setSessionChecked(value: boolean): void {
  useAuthStore.getState().setSessionChecked(value);
}
